<template>
  <div class="flex items-center justify-center min-h-screen bg-gray-100 w-full">
    <div
      class="text-center"
      style="
        border-radius: 8px;
        background: var(--White, #fff);
        box-shadow: 0px 4px 6px 0px rgba(0, 0, 0, 0.16);
        padding: 24px 60px 40px 60px;
        margin: 30px;
      "
    >
      <div class="flex justify-center mb-4"><Forbidden :fill="mainColor"></Forbidden></div>
      <h2
        class="text-5xl font-bold mb-8"
        :style="{ color: mainColor }"
        data-test="main-color-title"
      >
        403
      </h2>
      <h2 class="text-4xl font-bold mb-8">So sorry about this</h2>
      <p
        class="text-lg mb-6"
        data-test="error-message"
      >
        It appears you do not have permission to view this record.
      </p>
    </div>
  </div>
</template>

<script setup>
import Forbidden from '@/assets/Forbidden.vue';
import { useDonorStore } from '@/stores/DonorStore.js';
import { ref, onMounted } from 'vue';

let donorStore = useDonorStore();
const mainColor = ref('#4b5563');

onMounted(async () => {
  await donorStore.checkForMainColor();
  mainColor.value = donorStore.mainColor || '#4b5563';
});
</script>
